/* eslint-disable react/style-prop-object */
import React, { useContext, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Close from "../CloseBtn/Close";
import { popupcontext } from "../../../context/Popupscontext";
import Button from "../Button/Button";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { filtrationcontext } from "../../../context/Filtercontext";
import { useDeleteVehicleMutation } from "../../../Redux/service/Vehicles/Vehicles";
import { useDeleteDriverMutation } from "../../../Redux/service/Drivers/Drivers";
import { useDeleteGeofencesMutation } from "../../../Redux/service/Geofences/Geofences";
import { deletedGeofence } from "../../../Redux/service/Geofences/GeofenceSlice";
import { useDeleteNotificationMutation } from "../../../Redux/service/Notifications/Notifications";
import trans, { isRTL } from "../../../utils";
import { useDeleteGroupsMutation } from "../../../Redux/service/Groups/Groups";
import { useDeleteTechnicianMutation } from "../../../Redux/service/Technician/Technician";
import { useDeleteFormMutation } from "../../../Redux/service/Forms/Form";
import { useDeleteTaskMutation } from "../../../Redux/service/Tasks/Tasks";
import { useDeletePOIMutation } from "../../../Redux/service/POIS/POIs";
import { useDeleteRequestMutation } from "../../../Redux/service/Requests/Request";
import {
	useDeletePermissionMutation,
	useDeleteRoleMutation,
} from "../../../Redux/service/Roles&Permissions/RolesPermissions";
import { useDeleteCustomerMutation } from "../../../Redux/service/Customer/Customer";
import { useDeleteSnagMutation } from "../../../Redux/service/Snag/Snag";
import { useDeleteCompanyMutation } from "../../../Redux/service/Companies/Company";
import { useDeleteTeamMutation } from "../../../Redux/service/Teams/Teams";
import { useDeleteUserMutation } from "../../../Redux/service/Users/AuthUsers";
import { useDeleteConfigurationMutation } from "../../../Redux/service/Configuration/Configuration";
import { deleteDatabyId } from "../../../utils/IndexedDB";
import { useDeleteRegularMaintenanceMutation } from "../../../Redux/service/Maintenance/MaintenanceNew";

export default function Delete({
	vehicleId,
	driverId,
	userId,
	GeoId,
	notifiyid,
	GroupId,
	quotationid,
	handleDeleteClick,
	show,
	technicianId,
	maintenanceId,
	formId,
	taskId,
	poiId,
	requestId,
	permissionId,
	roleId,
	customerId,
	snagId,
	companyId,
	irId,
	teamId,
	configId,
}) {
	const {
		currentVehicleId,
		currentDriverId,
		currentUserId,
		currentSubUserId,
		currentGeofenceId,
		currentNotificationId,
		currentGroupId,
		currentTechnicianId,
		currentMaintenanceId,
		currentTaskId,
		currentPOIId,
		currentRequestId,
		handleClose,
		setDeleted,
		isDeleting,
		isEditing,
		setDeleteItem,
		currentFormId,
		currentPermissionId,
		currentRoleId,
		currentCustomerId,
		currentSnagId,
		currentCompanyId,
		currentTeamId,
		currentConfigurationId,
		currentIRId,
		setConfigurationId,
	} = useContext(popupcontext);
	const { Sort, setSort } = useContext(filtrationcontext);
	const dispatch = useDispatch();
	let [deleteVehicle] = useDeleteVehicleMutation();
	let [deleteDriver] = useDeleteDriverMutation();
	let [deleteUser] = useDeleteUserMutation();
	let [deleteGeofence] = useDeleteGeofencesMutation();
	let [deleteNotification] = useDeleteNotificationMutation();
	let [deleteGroup] = useDeleteGroupsMutation();
	let [deleteTechnician] = useDeleteTechnicianMutation();
	let [deleteRegularMintenance] = useDeleteRegularMaintenanceMutation();
	let [deleteForm] = useDeleteFormMutation();
	let [deleteTask] = useDeleteTaskMutation();
	let [deletePOI, { isLoading: isDeletingPOI }] = useDeletePOIMutation();
	let [deleteRequest] = useDeleteRequestMutation();
	let [deletePermission] = useDeletePermissionMutation();
	let [deleteRole] = useDeleteRoleMutation();
	let [deleteCustomer] = useDeleteCustomerMutation();
	let [deleteSnag] = useDeleteSnagMutation();
	let [deleteCompany] = useDeleteCompanyMutation();
	let [deleteTeam] = useDeleteTeamMutation();
	let [deleteConfiguration] = useDeleteConfigurationMutation();
	useEffect(() => {
		if (Sort.type === "" && Sort?.value === null) {
			setSort({ type: "id", value: true });
		}
	}, [Sort.type, Sort?.value, setSort]);
	const offlineMode = useSelector((state) => state.users.offlineMode);
	const currentUser = useSelector((state) => state.users.user);

	// Set when the backend refuses a POI deletion (409) because of open tasks or
	// active child POIs. Holds the full { code, message, blockers } payload so we
	// can show what is in the way instead of a one-line toast.
	const [poiBlocker, setPoiBlocker] = useState(null);

	const closePoiBlocker = () => {
		setPoiBlocker(null);
		handleClose("deleting");
	};

	const handleRemove = async (type, id, force = false) => {
		try {
			if (type === "vehicle") {
				await deleteVehicle(id).unwrap();
				setDeleteItem({ condition: true, value: "vehicles" });
				toast.success(trans("Vehicle Deleted Successfully"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			} else if (type === "driver") {
				await deleteDriver(id).unwrap();
				setDeleteItem({ condition: true, value: "drivers" });
				toast.success(trans("Driver Deleted Successfully"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			} else if (type === "user") {
				await deleteUser(id).unwrap();
				setDeleteItem({ condition: true, value: "users" });
				toast.success(trans("User Deleted Successfully"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			} else if (type === "subuser") {
				await deleteUser(id).unwrap();
				setDeleteItem({ condition: true, value: "users" });
				toast.success(trans("User Deleted Successfully"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			} else if (type === "geofence") {
				await deleteGeofence(id).unwrap();
				setDeleteItem({ condition: true, value: "geofences" });
				dispatch(deletedGeofence(id));
				toast.success(trans("Geofence Deleted Successfully"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			} else if (type === "notifications") {
				await deleteNotification(id).unwrap();
				setDeleteItem({ condition: true, value: "notifications" });
				toast.success(trans("Notification Deleted Successfully"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			} else if (type === "groups") {
				await deleteGroup(id).unwrap();
				setDeleteItem({ condition: true, value: "groups" });
				toast.success(trans("Group Deleted Successfully"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			} else if (type === "technician") {
				await deleteTechnician(id).unwrap();
				setDeleteItem({ condition: true, value: "technician" });
				toast.success(trans("Technician Deleted Successfully"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			} else if (type === "maintenance") {
				await deleteRegularMintenance(id).unwrap();
				setDeleteItem({ condition: true, value: "maintenance" });
				toast.success(trans("Regular Maintenance Deleted Successfully"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			} else if (type === "form") {
				await deleteForm(id).unwrap();
				setDeleteItem({ condition: true, value: "form" });
				toast.success(trans("Form Deleted Successfully"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			} else if (type === "pois") {
				const result = await deletePOI({ id, force }).unwrap();
				const cancelledCount = result?.data?.cancelledTaskCount ?? 0;
				setDeleteItem({ condition: true, value: "pois" });
				setPoiBlocker(null);
				toast.success(
					cancelledCount > 0
						? `${trans("POI Deleted Successfully")} - ${cancelledCount} ${trans(
								"task(s) cancelled"
						  )}`
						: trans("POI Deleted Successfully"),
					{
						// A forced delete just cancelled real work - leave it on screen
						// long enough to actually be read.
						autoClose: cancelledCount > 0 ? 3000 : 800,
						rtl: localStorage.getItem("lang") === "ar" ? true : false,
					}
				);
			} else if (type === "task") {
				await deleteTask(id).unwrap();
				setDeleteItem({ condition: true, value: "task" });
				toast.success(trans("Task Deleted Successfully"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			} else if (type === "request") {
				await deleteRequest(id).unwrap();
				setDeleteItem({ condition: true, value: "request" });
				toast.success(trans("Request Deleted Successfully"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			} else if (type === "permission") {
				await deletePermission(id).unwrap();
				setDeleteItem({ condition: true, value: "permission" });
				toast.success(trans("Permission Deleted Successfully"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			} else if (type === "role") {
				await deleteRole(id).unwrap();
				setDeleteItem({ condition: true, value: "role" });
				toast.success(trans("Role Deleted Successfully"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			} else if (type === "customer") {
				await deleteCustomer(id).unwrap();
				setDeleteItem({ condition: true, value: "customer" });
				toast.success(trans("Customer Deleted Successfully"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			} else if (type === "snag") {
				if (!offlineMode) {
					await deleteSnag(id).unwrap();
				} else {
					await deleteDatabyId("OfflineModeData", "Snag", currentSnagId);
				}
				setDeleteItem({ condition: true, value: "snag" });
				toast.success(trans("Snag Deleted Successfully"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			} else if (type === "company") {
				await deleteCompany(id).unwrap();
				setDeleteItem({ condition: true, value: "company" });
				toast.success(trans("Company Deleted Successfully"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			} else if (type === "configuration") {
				await deleteConfiguration(id).unwrap();
				await setConfigurationId(null);
				setDeleteItem({ condition: true, value: "configuration" });
				toast.success(trans("Configuration Deleted Successfully"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			} else if (currentIRId && offlineMode) {
				await deleteDatabyId("OfflineModeData", "IR", currentIRId);
				setDeleteItem({ condition: true, value: "IR" });
				toast.success(trans("Inspection Request Deleted Successfully"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			}
			setDeleted(true);
			handleClose("deleting");
		} catch (error) {
			// A blocked POI deletion is an expected outcome, not a failure: show
			// what is blocking it (and the force option) instead of a toast.
			if (type === "pois" && error?.status === 409 && error?.data?.code) {
				console.error("POI deletion blocked", error.data);
				setPoiBlocker(error.data);
				return;
			}
			if (
				type === "task" ||
				type === "pois" ||
				type === "form" ||
				type === "permission" ||
				type === "role" ||
				type === "customer" ||
				type === "snag" ||
				type === "company"
			) {
				console.error("error", error);
				toast.error(`${trans(error?.data?.message)}`, {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			} else {
				toast.error(trans("Something went wrong"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			}
		}
	};

	const getDeleteType = () => {
		if (currentSubUserId) {
			return "subuser";
		} else if (vehicleId && currentVehicleId === vehicleId) {
			return "vehicle";
		} else if (driverId && currentDriverId === driverId) {
			return "driver";
		} else if (userId && currentUserId === userId) {
			return "user";
		} else if (GeoId && currentGeofenceId === GeoId) {
			return "geofence";
		} else if (notifiyid && currentNotificationId === notifiyid) {
			return "notifications";
		} else if (quotationid) {
			return "quotation";
		} else if (GroupId && currentGroupId === GroupId) {
			return "groups";
		} else if (technicianId && currentTechnicianId === technicianId) {
			return "technician";
		} else if (maintenanceId && currentMaintenanceId === maintenanceId) {
			return "maintenance";
		} else if (formId && currentFormId === formId) {
			return "form";
		} else if (taskId && currentTaskId === taskId) {
			return "task";
		} else if (currentPOIId === poiId && poiId) {
			return "pois";
		} else if (requestId && currentRequestId === requestId) {
			return "request";
		} else if (permissionId && currentPermissionId === permissionId) {
			return "permission";
		} else if (roleId && currentRoleId === roleId) {
			return "role";
		} else if (customerId && currentCustomerId === customerId) {
			return "customer";
		} else if (snagId && currentSnagId === snagId) {
			return "snag";
		} else if (companyId && currentCompanyId === companyId) {
			return "company";
		} else if (currentConfigurationId === configId && !offlineMode) {
			return "configuration";
		} else if (currentIRId === irId && irId && offlineMode) {
			return "IR";
		}
		return null;
	};

	const Remove = () => {
		if (deleteType === "vehicle") {
			handleRemove(deleteType, vehicleId);
		}
		if (deleteType === "driver") {
			handleRemove(deleteType, driverId);
		}
		if (deleteType === "user") {
			handleRemove(deleteType, userId);
		}
		if (deleteType === "subuser") {
			handleRemove(deleteType, currentSubUserId);
		}
		if (deleteType === "geofence") {
			handleRemove(deleteType, currentGeofenceId);
		}
		if (deleteType === "notifications") {
			handleRemove(deleteType, currentNotificationId);
		}
		if (deleteType === "groups") {
			handleRemove(deleteType, currentGroupId);
		}
		if (deleteType === "technician") {
			handleRemove(deleteType, currentTechnicianId);
		}
		if (deleteType === "maintenance") {
			handleRemove(deleteType, currentMaintenanceId);
		}
		if (deleteType === "form") {
			handleRemove(deleteType, currentFormId);
		}
		if (deleteType === "task") {
			handleRemove(deleteType, currentTaskId);
		}
		if (deleteType === "pois") {
			handleRemove(deleteType, currentPOIId);
		}
		if (deleteType === "request") {
			handleRemove(deleteType, currentRequestId);
		}
		if (deleteType === "permission") {
			handleRemove(deleteType, currentPermissionId);
		}
		if (deleteType === "role") {
			handleRemove(deleteType, currentRoleId);
		}
		if (deleteType === "customer") {
			handleRemove(deleteType, currentCustomerId);
		}
		if (deleteType === "snag") {
			handleRemove(deleteType, currentSnagId);
		}
		if (deleteType === "company") {
			handleRemove(deleteType, currentCompanyId);
		}
		if (deleteType === "configuration") {
			handleRemove(deleteType, currentConfigurationId);
		}
		if (deleteType === "IR") {
			handleRemove(deleteType, currentIRId);
		}
	};
	const deleteType = getDeleteType();
	return (
		<>
			{show && (
				<img
					role="button"
					src={`${process.env.PUBLIC_URL}/assets/Delete.svg`}
					alt="delete"
					onClick={handleDeleteClick}
					title="delete"
				/>
			)}

			{isDeleting && !isEditing && deleteType && !poiBlocker && (
				<Modal show={isDeleting} centered dir={!isRTL ? "ltr" : "rtl"}>
					<Modal.Header>
						<div className="flex-between w-100">
							<Modal.Title>{trans("Delete")}</Modal.Title>
							<Close
								style="close-32 close"
								close={() => handleClose("deleting")}
								img="Close"
							/>
						</div>
					</Modal.Header>
					<Modal.Body>
						{trans("Are you sure you want to delete this")} {trans(deleteType)}{" "}
						{taskId}
					</Modal.Body>
					<Modal.Footer>
						<Button
							type={"default"}
							onClick={() => handleClose("deleting")}
							text={trans("Cancel")}
						/>
						<Button text={trans("Delete")} onClick={Remove} danger={true} />
					</Modal.Footer>
				</Modal>
			)}

			{poiBlocker && (
				<PoiBlockerModal
					blocker={poiBlocker}
					isAdmin={!!currentUser?.administrator}
					isLoading={isDeletingPOI}
					onClose={closePoiBlocker}
					onForce={() => handleRemove("pois", currentPOIId, true)}
				/>
			)}
		</>
	);
}

// Second-step dialog shown when the backend refuses a POI deletion (409).
// Lists what is actually blocking it rather than collapsing it into a toast.
function PoiBlockerModal({ blocker, isAdmin, isLoading, onClose, onForce }) {
	const { code, blockers } = blocker;
	const hasChildren = code === "POI_HAS_ACTIVE_CHILDREN";

	const openTasks = blockers?.openTasks ?? [];
	const activeChildren = blockers?.activeChildren ?? [];
	const openTaskCount = blockers?.openTaskCount ?? openTasks.length;
	const activeChildCount = blockers?.activeChildCount ?? activeChildren.length;

	// The backend caps the task list at 20; say so rather than silently truncating.
	const hiddenTaskCount = Math.max(0, openTaskCount - openTasks.length);

	// Children can never be forced away - that would orphan the subtree.
	const canForce = !hasChildren && blockers?.canForceDelete;

	return (
		<Modal show centered dir={!isRTL ? "ltr" : "rtl"} onHide={onClose}>
			<Modal.Header>
				<div className="flex-between w-100">
					<Modal.Title>
						{trans(
							hasChildren
								? "This POI has active child POIs"
								: "This POI has unresolved tasks"
						)}
					</Modal.Title>
					<Close style="close-32 close" close={onClose} img="Close" />
				</div>
			</Modal.Header>

			<Modal.Body>
				<p className="mb-3">
					{hasChildren
						? `${activeChildCount} ${trans(
								"active child POI(s) must be deleted first"
						  )}.`
						: `${openTaskCount} ${trans(
								"unresolved task(s) are still attached to it"
						  )}.`}
				</p>

				<div style={{ maxHeight: 260, overflowY: "auto" }}>
					{hasChildren
						? activeChildren.map((child) => (
								<div
									key={child.id}
									className="d-flex justify-content-between align-items-center py-2"
									style={{ borderBottom: "1px solid #eee" }}
								>
									<span>
										<strong>{child.code || `#${child.id}`}</strong> {child.name}
									</span>
									<span style={{ opacity: 0.7 }}>{trans(child.type)}</span>
								</div>
						  ))
						: openTasks.map((task) => (
								<div
									key={task.id}
									className="d-flex justify-content-between align-items-center py-2"
									style={{ borderBottom: "1px solid #eee" }}
								>
									<span>
										<strong>{task.code || `#${task.id}`}</strong> {task.name}
									</span>
									<span style={{ opacity: 0.7 }}>
										{trans(task.status)} ·{" "}
										{task.assignedTo?.name
											? `${trans("Assigned to")} ${task.assignedTo.name}`
											: trans("Unassigned")}
									</span>
								</div>
						  ))}

					{hiddenTaskCount > 0 && (
						<div className="py-2" style={{ opacity: 0.7 }}>
							+ {hiddenTaskCount} {trans("and more")}
						</div>
					)}
				</div>

				<p className="mt-3 mb-0" style={{ opacity: 0.85 }}>
					{hasChildren
						? `${trans("Delete these child POIs first, then delete this one")}.`
						: canForce && isAdmin
						? `${trans("Cancelling is permanent and cannot be undone")}.`
						: `${trans("Resolve or reassign these tasks first")}.`}
				</p>

				{!hasChildren && canForce && !isAdmin && (
					<p className="mb-0" style={{ opacity: 0.85 }}>
						{trans("Only administrators can cancel these tasks")}.
					</p>
				)}
			</Modal.Body>

			<Modal.Footer>
				<Button type={"default"} onClick={onClose} text={trans("Close")} />
				{!hasChildren && canForce && isAdmin && (
					<Button
						danger={true}
						loading={isLoading}
						onClick={onForce}
						text={`${trans("Cancel these tasks and delete POI")} (${openTaskCount})`}
					/>
				)}
			</Modal.Footer>
		</Modal>
	);
}
